import React, { FC } from 'react';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { UserStatusRouter } from './UserStatusRouter';
import { PublicRestrictedModal } from './public/PublicRestrictedModal';
import styles from './restricted_modal.module.scss';

type Props = {
  source: string;
  isOpen?: boolean;
  onRequestClose?: () => void;
  title?: string;
};

export const RestrictedModal: FC<Props> = ({
  onRequestClose = () => {},
  source,
  title,
  isOpen = false,
}) => {
  if (!isOpen) {
    return null;
  }

  const isFeatureRectriction = !!title;

  return (
    <UserStatusRouter
      onRequestClose={onRequestClose}
      isOpen={isOpen}
      source={source}
    >
      <PublicRestrictedModal
        source={source}
        closeModal={onRequestClose}
        title={
          isFeatureRectriction ? (
            title
          ) : (
            <FormattedMessage
              id="modal-restricted/RestrictedModal.tsx/1"
              values={{ br: <br /> }}
            />
          )
        }
        subtitle={
          isFeatureRectriction ? (
            <FormattedMessage
              id="modal-restricted/RestrictedModal.tsx/1"
              values={{ br: <br /> }}
            />
          ) : null
        }
        icon={
          isFeatureRectriction ? (
            <i
              className={classNames(
                'material-icons icons__lock',
                styles.featureRestrictionIcon,
              )}
            />
          ) : (
            <span className={styles.logo} />
          )
        }
      />
    </UserStatusRouter>
  );
};
